import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendRequest } from "../../apis/APIs";
import { handleApiResponse } from "../../apis/apiUtils";
import { useSelector, useDispatch } from 'react-redux';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { FloatingLabel, Form } from 'react-bootstrap';
import appRoutes from '../../configs/AppRoutes';

const ForgotPassword = () => {
    const [userDetail, setUserDetail] = useState({ email: '' });
    const [errorsInfo, setErrorsInfo] = useState({});
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { loading } = useSelector((state) => state.common);
    const navigate = useNavigate();
    const params = useParams();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetail({ ...userDetail, [name]: value });

        if (errorsInfo.email) {
            setErrorsInfo({ ...errorsInfo, email: '' });
        }
    };

    const validateEmail = () => {
        let isValid = true;
        let errors = {};

        if (!userDetail.email || userDetail.email.trim() === '') {
            errors.email = 'Please enter email address';
            isValid = false;
        }
        setErrorsInfo(errors);
        return isValid;
    };


    const sentForgetPassword = async (e) => {
        try {
            e.preventDefault();

            if (validateEmail()) {
            dispatch(callCommonAction({ loading: true }));

                const res = await sendRequest(`/forgot-password`, "POST", userDetail);
                handleApiResponse(res);
                if (res.data.type === 'success') {
                    dispatch(callCommonAction({ loading: false }));

                    // Clear the email input field on success
                    setUserDetail({ ...userDetail, email: '' });
                }
            }
        } catch (error) {
            dispatch(callCommonAction({ loading: false }));

            toast.error(error?.response?.data?.message);
        }
    };

    return (


        <>

            <div className="d-flex justify-content-center w-100 login-main">
                <div className="col-md-12 col-lg-12">
                    <div className="d-flex flex-md-row flex-column shadow rounded overflow-hidden vh-100 align-items-center">


                        <div className="p-4 p-md-6 w-100 px-5">
                            <div className='form-box m-auto'>
                                <div className="d-flex flex-wrap justify-content-center mb-4">
                                    <h3 className='text-uppercase'>Reset Password</h3>
                                    <p className="">Please enter it below to verify your identity.</p>
                                </div>
                                <form noValidate onSubmit={sentForgetPassword}>
                                    <div className="mb-3">
                                        <div className='relative'>
                                            <i class="fa-solid fa-envelope input-i"></i>
                                            <input placeholder='Enter Email Address' type="text" name="email" id="email" className="form-control" value={userDetail.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {errorsInfo.email && (<p className="text-danger">{errorsInfo.email}</p>)}
                                    </div>
                                    <div className="text-center mb-3">
                                        <button disabled={loading} className="w-100 btn-lg btn-primary shadow btn btn-primary btn-yellow">
                                            {
                                                loading
                                                    ?
                                                    <span className="indicator-progress" style={{ display: 'block' }}>
                                                        Please wait...
                                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                    </span>
                                                    :
                                                    <span className="indicator-label" onSubmit={sentForgetPassword}>Submit</span>
                                            }
                                        </button>
                                    </div>


                                    <div className="d-flex justify-content-center align-items-center mb-3 text-center">
                                        <a href="#" className="text-decoration-none border-btn d-block w-100 rounded btn-lg py-2 btn-grey shadow btn btn-outline-danger w-100 my-1 py-2" onClick={(e) => {
                                            e.preventDefault();
                                            navigate(appRoutes.loginPageRoute)
                                        }}>
                                            Cancel
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="w-100 p-15 vh-100 form-right d-flex align-items-center justify-content-center">

                            <div className='login-right-inner text-center'>
                                <span className='d-block mb-4'><img src="./assets/images/image.png" alt="No Data Found" /></span>
                                <img src="./assets/images/login-img.png" alt="No Data Found" />
                                <h3 className='mt-4 text-white'>Document Selection and Aggregation Tool</h3>
                                <p className='fs-6 text-white mt-3'>A <b>PDF builder</b> tool that allows users to create <b>customized</b> PDFs by selecting pages from multiple <b>PDF</b> files and adding new content through an integrated form interface.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </>

    )
}

export default ForgotPassword
